import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';
import EvidenceAddTable from 'components/EvidenceAddTable';

const EvidenceAdd = ({ 
    evidence = [], 
    onRemove,
    onOpenDialog,
    observation
}) => {
    if (evidence.length === 0) {
        return (
            <>
                <Typography level="body2" sx={{ fontStyle: 'italic', mb: 2 }}>
                    No evidence added yet.
                </Typography>
                <Button onClick={onOpenDialog}>
                    Add Evidence
                </Button>
            </>
        );
    }

    return (
        <>
            <EvidenceAddTable 
                evidences={evidence} 
                onRemove={onRemove}
                observation={observation}
            />
            <Button onClick={onOpenDialog} sx={{ mt: 2 }}>
                Add Another Evidence
            </Button>
        </>
    );
};

EvidenceAdd.propTypes = {
    evidence: PropTypes.array,
    onRemove: PropTypes.func.isRequired,
    onOpenDialog: PropTypes.func.isRequired,
    observation: PropTypes.object
};

export default EvidenceAdd;